import React, { useState } from 'react';

import ApiClient from '../services/fuelandmoreapi';

import './AddFleet.css';

interface AddFleetProps {
    apiUrl: string;
    clientDomain?: string;
    onFleetAdded: (fleet: { id: string; name: string; vessels: any[] }) => void;
}

const AddFleet: React.FC<AddFleetProps> = ({ apiUrl, onFleetAdded, clientDomain }) => {
    const [isAddingFleet, setIsAddingFleet] = useState(false);
    const [newFleetName, setNewFleetName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleAddFleetClick = () => setIsAddingFleet(true);

    const handleCancelAddFleet = () => {
        setIsAddingFleet(false);
        setNewFleetName('');
        setError(null);
    };

    const handleSaveAddFleet = async (e?: React.FormEvent) => {
        if (e) e.preventDefault();
        setError(null);
        if (newFleetName.trim().length < 3) {
            setError('Fleet name must be at least 3 characters.');
            return;
        }
        setLoading(true);
        try {
            const apiClient = new ApiClient(apiUrl);
            
            let userClientDomain = "";
            
            if (!clientDomain) {

                const user = localStorage.getItem('user');
                if (!user) throw new Error('User not found in localStorage');
                const userEmail = JSON.parse(user).email;
                const clientUsersResponse = await apiClient.getClientUsers(userEmail);
                const clientUsers = clientUsersResponse.data;
                if (clientUsers.length === 0) throw new Error('No clients found for the user');
                userClientDomain = clientUsers[0].clientDomain;
            
            }

            const newFleet = await apiClient.createClientFleet({
                name: newFleetName.trim(),
                clientDomain: clientDomain ?? userClientDomain,
                vessels: [],
            });
        
            onFleetAdded({ id: newFleet.data.id, name: newFleet.data.name, vessels: [] });

            setIsAddingFleet(false);
            
            setNewFleetName('');
        
        } catch (error) {
            setError('Failed to create fleet. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (!isAddingFleet) {
        return (
            <div className="add-fleet-button-container">
                <button className="primary-button" onClick={handleAddFleetClick}>
                    + Add Fleet
                </button>
            </div>
        );
    }

    return (
        <div className="add-fleet-modal">
            <form className="add-fleet-form" onSubmit={handleSaveAddFleet}>
                <input
                    id="fleet-name"
                    type="text"
                    value={newFleetName}
                    onChange={e => setNewFleetName(e.target.value)}
                    placeholder="Enter fleet name"
                    required
                />
                {error && <div className="form-error">{error}</div>}
                <div className="form-actions">
                   

                    <button type="button" onClick={handleCancelAddFleet} disabled={loading}>
                        Cancel
                    </button>
                   
                    <button className="save-btn" type="submit" disabled={loading}>
                        {loading ? 'Saving...' : 'Save'}
                    </button>

                </div>
            </form>
        </div>
    );
};

export default AddFleet;